import axios from 'axios'
import config from '@/config'
import helper from './vueHelper'

export default {
  request(page, method, uri, data = null, success = null, fail = null, withFile = false, responseType = 'json') {
    if (!page) {
      console.error('API function call requires page argument')
      return
    }

    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    var url =   config.serverURI + uri


    if (data instanceof FormData) {
      data.append('ApiKey', config.apiKey)
      data.append('ApiSystemName', config.apiSystemName)


      if(!data.get("LocaleCode")){
        data.append("LocaleCode",helper.getLocaleCode());
      }
      if(helper.includes(page.$router.history.current.path,"/Mobile/")||(page.$msal&&page.$msal.isAuthenticated())){
        data.append('extendSession', true)
      }else{
        data.append('extendSession', false)
      }

    } else {
      data.ApiKey = config.apiKey
      data.ApiSystemName = config.apiSystemName
      if(!data.LocaleCode){
        data.LocaleCode = helper.getLocaleCode();
      }

      if(helper.includes(page.$router.history.current.path,"/Mobile/")||(page.$msal&&page.$msal.isAuthenticated())){
        data.extendSession = true
      }else{
        data.extendSession = false
      }

    }

    // // Reset message before call
    page.$store.dispatch('message/actionSetMessage', { message: null })

    page.$store.dispatch('actionSetBlock', true)


    axios({
      rejectUnauthorized:config.rejectUnauthorized,
      method: method,
      url: url,
      data: data,
      crossDomain: true,
      responseType: responseType,
      headers: {
        'Content-type': withFile === true ? 'multipart/form-data; charset=utf-8' : 'application/json; charset=utf-8'
      }
    }).then(response => {
      // console.log(response)
      // reset timeout after each call (web only
      if(!helper.includes(page.$router.history.current.path,"/Mobile/")&&!(page.$msal&&page.$msal.isAuthenticated())){
        page.$store.dispatch('actionResetTimeout')
      }

      if (responseType === 'blob') {
        //const suggestedFileName = response.headers['filename'] || response.headers['content-disposition'].split("filename=")[1];
        var suggestedFileName;
        if(response.headers['filename'])
          suggestedFileName = response.headers['filename']
        else{
          suggestedFileName= response.headers['content-disposition'].split("filename=")[1].split(";")[0]
        }
        suggestedFileName = suggestedFileName.replaceAll('"','');
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          window.navigator.msSaveBlob(response.data, suggestedFileName)
          return
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          // console.log(response.data);
          console.log(new Blob([response.data]));
          console.log(suggestedFileName);

          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', suggestedFileName || 'file.zip')
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)

          page.$store.dispatch('actionSetBlock', false)
          if (typeof success === 'function') {
            success.call(page, r)
          }

          return
        }
      }else if (responseType === 'stream'){
        //console.log(response);

      }

      var r = response.data
      if (r.code !== 200 && config.logApplicationError) {
        console.error(r.message)
        page.$store.dispatch('message/actionSetMessage', { message: r.message })
      }


      page.$store.dispatch('actionSetBlock', false)

      if (typeof success === 'function') {
        success.call(page, r)
      }


    }).catch(error => {
      // reset timeout after each call
      //page.$store.dispatch('actionResetTimeout')


      if (error.response && error.response.status === 440) {
        // unblock ui
        $('.modal-backdrop').remove()

        // If it is not login page, then session timeout, redirect to login
        if (page.$router.currentRoute.path !== '/login') {
          page.$store.dispatch('actionSetToken', null);
          page.$router.replace('/login?redirect=' + page.$router.currentRoute.fullPath)
        } else {
          if (typeof fail === 'function') {
            fail.call(page, error)
          }
        }
      } else if (error.response && error.response.status === 302) {
        // unblock ui
        helper.done();

        page.$router.replace({
          name: '404',
          query: {
            msg: `You don't have the permission to access on this page (CODE:SUBSCRIPTION)`,
          }
        })
      }else if (error.response && error.response.status === 404) {
        // unblock ui
        helper.done();

        page.$router.replace({
          name: '404'
        })
      } else {
        if (error.response && error.response.data && error.response.data.Message) {
          console.log(page.$store)

          page.$store.dispatch('message/actionSetMessage', { message: error.response.data.Message })
          console.error(error.response.data.Message)
        } else if (error.response && responseType === 'blob' && error.response.statusText) {
          page.$store.dispatch('message/actionSetMessageStrOnly', error.response.statusText)

        } else if (error.message) {
          // page.$store.dispatch('actionSetMessage', error.message)
          console.error(error.message)
          page.$store.dispatch('message/actionSetMessage', { message: error.message })
        }

        page.$store.dispatch('actionSetBlock', false)


        if (typeof fail === 'function') {
          fail.call(page, error)
        }
      }
    })
  },

  requestMultipleProgressShow(page) {
    // // Reset message before call
    page.$store.dispatch('message/actionSetMessage', { message: null });
    ;
  },
  requestMultipleProgressSuccess(page) {
    // reset timeout after each call
    // page.$store.dispatch('actionResetTimeout')

    //do not support blob
    // if (responseType === 'blob') {
    //   const suggestedFileName = response.headers['filename']

    //   if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    //     window.navigator.msSaveBlob(response.data, suggestedFileName)
    //     return
    //   } else {
    //     const url = window.URL.createObjectURL(new Blob([response.data]))
    //     const link = document.createElement('a')
    //     link.href = url
    //     link.setAttribute('download', suggestedFileName || 'file.zip')
    //     document.body.appendChild(link)
    //     link.click()
    //     window.URL.revokeObjectURL(url)
    //
    //     page.$store.dispatch('actionSetBlock', false)
    //     return
    //   }
    // }

    // var r = response.data
    // if (r.code !== 200 && config.logApplicationError) {
    //   console.error(r.message)
    // }

    // if (typeof success === 'function') {
    //   success.call(page, r)
    // }

  },
  requestMultipleProgressError(page, error) {
    console.log(error);
    // reset timeout after each call
    //page.$store.dispatch('actionResetTimeout')

    if (error.response && error.response.status === 440) {
      // unblock ui
      $('.modal-backdrop').remove()

      // If it is not login page, then session timeout, redirect to login
      if (page.$router.currentRoute.path !== '/login') {
        page.$store.dispatch('actionSetToken', null);
        page.$router.replace('/login?redirect=' + page.$router.currentRoute.fullPath)
      } else {
        if (typeof fail === 'function') {
          fail.call(page, error)
        }
      }
    } else if (error.response && error.response.status === 404) {
      // unblock ui
      $('.modal-backdrop').remove()

      page.$router.replace({
        name: '404'
      })
    } else {
      if (error.response && error.response.data && error.response.data.Message) {
        console.log(page.$store)

        page.$store.dispatch('message/actionSetMessage', { message: error.response.data.Message })
        console.error(error.response.data.Message)
      } else if (error.message) {
        // page.$store.dispatch('actionSetMessage', error.message)
        console.error(error.message)
        page.$store.dispatch('message/actionSetMessage', { message: error.message })
      }

      if (typeof fail === 'function') {
        fail.call(page, error)
      }
    }


  },
  requestMultiple(page, method, uri, data = null, responseType = 'json') {
    if (!page) {
      console.error('API function call requires page argument')
      return
    }

    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    var url = config.serverURI + '/api' + uri

    // console.log(url);
    // console.log(data);

    if (data instanceof FormData) {
      data.append('ApiKey', config.apiKey)
      data.append('ApiSystemName', config.apiSystemName)
    } else {
      data.ApiKey = config.apiKey
      data.ApiSystemName = config.apiSystemName
    }
    let withFile = false;
    // // Reset message before call
    page.$store.dispatch('message/actionSetMessage', { message: null })

    return axios({
      method: method,
      url: url,
      data: data,
      crossDomain: true,
      responseType: responseType,
      headers: {
        'Content-type': withFile === true ? 'multipart/form-data; charset=utf-8' : 'application/json; charset=utf-8'
      }
    });
  },

}